/** @jsxImportSource @emotion/react */
import React from 'react'

import * as styles from './styles'

export default function Emoji30() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 45 45" css={styles.svg}>
      <g transform="matrix(1,0,0,1,-743.524,-3280.26)">
        <g transform="matrix(0.683279,0,0,0.683279,373.769,3232.44)">
          <g transform="matrix(0.937093,0,0,0.937093,65.7035,-85.3866)">
            <g opacity="0.75">
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M542,165.3c-19.277,0 -35.14,15.863 -35.14,35.14c0,19.277 15.863,35.14 35.14,35.14c19.277,0 35.14,-15.863 35.14,-35.14c-0.027,-19.267 -15.873,-35.113 -35.14,-35.14m0,65.89c-16.869,0 -30.75,-13.881 -30.75,-30.75c0,-16.869 13.881,-30.75 30.75,-30.75c16.869,0 30.75,13.881 30.75,30.75c-0.016,16.863 -13.887,30.734 -30.75,30.75"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M527.25,195.41c0.856,0.847 2.254,0.847 3.11,0l6.59,-6.59c0.842,-0.858 0.842,-2.252 0,-3.11l-6.59,-6.59c-0.408,-0.386 -0.949,-0.601 -1.511,-0.601c-1.206,0 -2.2,0.994 -2.2,2.2c0,0.562 0.215,1.103 0.601,1.511l5,5l-5,5c-0.842,0.858 -0.842,2.252 0,3.11"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M553.61,195.41c0.852,0.846 2.248,0.846 3.1,0c0.853,-0.853 0.853,-2.257 0,-3.11l-5,-5l5,-5c0.476,-0.417 0.749,-1.021 0.749,-1.654c0,-1.206 -0.993,-2.2 -2.2,-2.2c-0.631,0 -1.232,0.271 -1.649,0.744l-6.61,6.52c-0.853,0.853 -0.853,2.257 0,3.11l6.61,6.59Z"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M563.26,201.17c-0.421,-0.461 -1.016,-0.726 -1.64,-0.73l-39.27,0c-0.625,0.002 -1.221,0.267 -1.64,0.73c-0.418,0.466 -0.618,1.088 -0.55,1.71c1.406,10.923 10.807,19.192 21.82,19.192c11.013,0 20.414,-8.269 21.82,-19.192c0.067,-0.62 -0.129,-1.241 -0.54,-1.71m-21.26,16.83c-7.985,0.001 -15.012,-5.447 -17,-13.18l34,0c-1.982,7.737 -9.013,13.188 -17,13.18"
                  css={styles.svg}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
